import React, { useEffect, useState } from "react";
import { PutAwayInvoiceWrapper } from "./PutAwayInvoices.style";
import UserGreeting from "../../../components/UserGreeting/UserGreeting";
import { Input, Segmented, message } from "antd";
import PutAwayTable from "../components/PutAwayTable/PutAwayTable";
import TitleWrapper from "../../../components/TitleWrap/TitleWrap";
import {
  fetchBatchPutAwayDetails,
  fetchUnrackedBillData,
  fetchVendorList,
} from "../service/putAwayServices";
import { connect } from "react-redux";
import Select from "react-select";
import {
  API_TYPE,
  SOMETHING_WENT_WRONG,
  warehouseId,
} from "../../../constants";
import { handleError } from "../../../redux/makeApiCall";
import TMLoader from "../../../components/Loader/Loader";
import OfflinePage from "../../OfflinePage/OfflinePage";
import { Base64func } from "../../../components/Base64Func/Base64func";

const STATUS_MAPPING = {
  inProgress: {
    label: "In progress",
    value: 2,
  },
  pending: {
    label: "Yet to rack",
    value: 1,
  },
  all: {
    label: "All",
    value: null,
  },
};
const MESSAGE_MAPPING = {
  allFieldsRequied: "Select all fields",
};
const INVOICE_TITLE = "Invoices To Rack";
const PAGINATION_INIT = {
  current: 1,
  pageSize: 10,
  total: 10,
};
const PutAwayInvoices = (props) => {
  const [vendorListLoading, setVendorListLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [billNumber, setBillNumber] = useState("");
  const [vendorId, setVendorId] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [pagination, setPagination] = useState(PAGINATION_INIT);
  const [status, setStatus] = useState(null);
  const { current } = pagination;
  const column = [
    {
      title: "Bill Number",
      dataIndex: "billNumber",
      key: "billNumber",
      align: "center",
    },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      key: "vendorName",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
    },
  ];

  const getVendors = async () => {
    setVendorListLoading(true);
    try {
      const response = await fetchVendorList({
        access_token: props.access_token,
      });
      if (response.status === 200) {
        setVendors(
          response?.data?.map((item) => {
            return { value: item, label: item.vendorName };
          }) || []
        );
      } else {
        setVendors([]);
      }
      setVendorListLoading(false);
    } catch (error) {
      const err = handleError(error, API_TYPE.OLD);
      message.error(err || SOMETHING_WENT_WRONG);
      setVendors([]);
      setVendorListLoading(false);
    }
  };
  const fetchInvoices = async (page = 0) => {
    setIsLoading(true);
    try {
      const params = {
        access_token: props.access_token,
        warehouseId,
        page,
        status,
      };
      const response = await fetchUnrackedBillData(params);
      if (response.data.statusCode === 200) {
        setDataSource(response?.data?.responseData?.unrackedList || []);
        setPagination((prev) => ({
          ...prev,
          total: response?.data?.responseData?.totalCount || 10,
        }));
      } else if (response.data.statusCode === 204) {
        setDataSource([]);
        setPagination(PAGINATION_INIT);
        message.error(response.data.message);
      } else {
        throw new Error(response.data.message);
      }
      setIsLoading(false);
    } catch (error) {
      const err = handleError(error, API_TYPE.NEW);
      message.error(err || SOMETHING_WENT_WRONG, 1);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (props.isOnline) fetchInvoices(current - 1);
  }, [current, status, props.isOnline]);
  useEffect(() => {
    if (props.isOnline) getVendors();
  }, [props.isOnline]);

  const handleSearch = () => {
    if (vendorId && billNumber && billNumber.trim().length) {
      props.history.push({
        pathname: `/put-away-racking/${Base64func(
          vendorId,
          "encode"
        )}/${Base64func(billNumber, "encode")}`,
      });
    } else {
      message.error(MESSAGE_MAPPING.allFieldsRequied);
    }
  };
  const handleRowClick = (record) => {
    props.history.push({
      pathname: `/put-away-racking/${Base64func(
        record.vendorId,
        "encode"
      )}/${Base64func(record.billNumber, "encode")}`,
    });
  };

  return props.isOnline ? (
    <PutAwayInvoiceWrapper className="centerScreen">
      {isLoading && <TMLoader />}
      <UserGreeting />
      <div className="searchInvoiceWrapper">
        <div className="searchInvoice">
          <div className="billNumber">
            <div className="fieldWrapper">
              <label htmlFor="billNumber">Bill Number</label>
              <Input
                onChange={(e) => {
                  setBillNumber(e.target.value);
                }}
                size="large"
                id="billNumber"
              />
            </div>
          </div>
          <div className="invoiceNumber fieldWrapper">
            <label htmlFor="">Vendor Name</label>
            <Select
              isLoading={vendorListLoading}
              isDisabled={vendorListLoading}
              options={vendors}
              onChange={(e) => {
                setVendorId(e.value.vendorId);
              }}
            />
          </div>
        </div>
        <button onClick={handleSearch} className="bbtn">
          Search
        </button>
      </div>

      <div className="statusTabs">
        <TitleWrapper title={INVOICE_TITLE} />
        <div className="statusWrapper">
          {/* <div className="label">Status :</div> */}
          <Segmented
            size="large"
            options={[
              {
                label: STATUS_MAPPING.all.label,
                value: STATUS_MAPPING.all.value,
              },
              {
                label: STATUS_MAPPING.inProgress.label,
                value: STATUS_MAPPING.inProgress.value,
              },
              {
                label: STATUS_MAPPING.pending.label,
                value: STATUS_MAPPING.pending.value,
              },
            ]}
            onChange={(value) => {
              setStatus(value);
              setPagination(PAGINATION_INIT);
            }}
          />
        </div>
      </div>
      <div className="invoiceTable">
        <PutAwayTable
          columns={column}
          dataSource={dataSource}
          onRowClick={handleRowClick}
          pagination={pagination}
          setPagination={setPagination}
        />
      </div>
    </PutAwayInvoiceWrapper>
  ) : (
    <OfflinePage />
  );
};

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
});

export default connect(mapStateToProps, {})(PutAwayInvoices);
